import { withStylePrefix } from '../../common/withStylePrefix';
import { DataTableHeaderComponent, datatableHeaderTemplate } from './DataTableHeader';
import styles from './DataTableHeader.styles.scss';
export const dataTableHeaderDefinition = {
    baseName: 'data-table-header',
    template: datatableHeaderTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonDataTableHeader = DataTableHeaderComponent.compose(dataTableHeaderDefinition);
